// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Site} from '../../core/_models'

type Props = {
  row: Row<Site>
}

const CustomRow: FC<Props> = ({row}) => (
  // <Link to='/crafted/pages/profile/campaigns'>
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
  // </Link>
)

export {CustomRow}
